module.exports={render:function (){
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-list-item",
    class: ( _obj = {
      'cart-mode': _vm.cartMode,
      'is-catalog': _vm.isCatalog
    }, _obj[("sku--" + (_vm.product.sku))] = 1, _obj )
  }, [_c('h3', {
    staticClass: "page-title text-center"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    class: _vm.wrapperClasses
  }, [_c('div', {
    staticClass: "product",
    class: _vm.extraClasses
  }, [(_vm.isSoldout) ? _c('div', {
    staticClass: "ribbon"
  }, [_c('div', {
    staticClass: "ribbon--name"
  }, [_vm._v("Sold out")])]) : _vm._e(), _vm._v(" "), (_vm.isComingSoon) ? _c('div', {
    staticClass: "ribbon"
  }, [_c('div', {
    staticClass: "ribbon--name -coming-soon"
  }, [_vm._v("Coming Soon")])]) : _vm._e(), _vm._v(" "), (!_vm.cartMode) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPageSelector),
      expression: "showPageSelector"
    }],
    staticClass: "product__block product__image"
  }, [_c('page-selector', {
    ref: "selector",
    attrs: {
      "product": _vm.product
    },
    on: {
      "pages": _vm.getPageSuccess
    },
    model: {
      value: (_vm.choices.page),
      callback: function($$v) {
        _vm.$set(_vm.choices, "page", $$v)
      },
      expression: "choices.page"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.cartMode) ? _c('div', {
    staticClass: "product-cart__info"
  }, [_c('div', {
    staticClass: "product-cart__image"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.firstImage.preview
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "product-cart__title"
  }, [_vm._v("\n          " + _vm._s(_vm.product.name) + "\n          "), (_vm.product.catalogSku) ? _c('span', {
    staticClass: "product-catalog-name"
  }, [_vm._v("( " + _vm._s(_vm.catalogName(_vm.product)) + " )")]) : _vm._e(), _vm._v(" "), (_vm.isStockProductType) ? _c('product-choice-summary', {
    attrs: {
      "product": _vm.product,
      "choices": _vm.choices,
      "quantity": _vm.quantity
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "product-cart__value"
  }, [_vm._v("\n          " + _vm._s(_vm._f("comma")(_vm.product.price)) + " ฿\n          "), (_vm.shippingFee) ? _c('div', {
    staticClass: "product-cart__shipping"
  }, [_vm._v("+ " + _vm._s(_vm.shippingFee) + " ฿")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "product__block--form"
  }, [_c('div', {
    staticClass: "block-border radius block shadow"
  }, [(_vm.isCatalog || _vm.forceNoActions) ? _c('div', [_c('div', {
    staticClass: "product__action -view-details"
  }, [_c('router-link', {
    staticClass: "btn btn--purple",
    attrs: {
      "to": {
        name: 'product_detail',
        params: {
          sku: _vm.product.sku
        }
      }
    }
  }, [_vm._v("View details")])], 1)]) : _c('div', [_c('product-choice', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isStockProductType && _vm.showAttributes),
      expression: "isStockProductType && showAttributes"
    }],
    ref: "attributes",
    attrs: {
      "product": _vm.product,
      "initialChoices": _vm.choices
    },
    on: {
      "attrChanged": _vm.attrChanged
    }
  }), _vm._v(" "), (_vm.isDonateProductType && _vm.showAttributes) ? _c('product-donate-choice', {
    ref: "donateChoice",
    attrs: {
      "product": _vm.product,
      "choices": _vm.donateConfig.choices,
      "minimum": 20,
      "defaults": _vm.donateConfig.default,
      "custom": _vm.donateConfig.customAmount,
      "classes": _vm.donateChoiceClasses
    },
    on: {
      "change": _vm.amountChanged
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$route.query.type !== 'monthly') ? _c('product-donate-type', {
    attrs: {
      "product": _vm.product
    },
    model: {
      value: (_vm.donateType),
      callback: function($$v) {
        _vm.donateType = $$v
      },
      expression: "donateType"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isStockProductType && _vm.showAttributes && _vm.$utils.isProductAvailable(this.product)) ? _c('div', {
    staticClass: "mt-30",
    class: {
      '-error': !_vm.stockAvailable
    }
  }, [_vm._v("\n              จำนวนรายการคงเหลือ:\n              "), (!_vm.stockChecking) ? _c('em', [(_vm.stockQuantity > 0) ? _c('span', [_vm._v("ประมาณ ")]) : _vm._e(), _vm._v(_vm._s(_vm._f("comma")(_vm.stockQuantity)) + " รายการ")]) : _c('em', [_vm._v("กำลังตรวจสอบ...")]), _vm._v(" "), (_vm.stockAvailable) ? _c('div', {
    staticClass: "fl-right"
  }, [_vm._v("✔")]) : _c('div', {
    staticClass: "fl-right"
  }, [_vm._v("✗")]), _vm._v(" "), _c('br'), _c('button', {
    staticClass: "text-muted-ss",
    attrs: {
      "disabled": _vm.stockChecking
    },
    on: {
      "click": function($event) {
        return _vm.checkStock()
      }
    }
  }, [_vm._v("ตรวจสอบอีกครั้ง")])]) : _vm._e(), _vm._v(" "), _c('donor-info', {
    model: {
      value: (_vm.choices.info),
      callback: function($$v) {
        _vm.$set(_vm.choices, "info", $$v)
      },
      expression: "choices.info"
    }
  }), _vm._v(" "), _c('product-cart-action', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.cartMode),
      expression: "!cartMode"
    }],
    ref: "cartAction",
    style: ({
      margin: 0
    }),
    attrs: {
      "stockAvailable": _vm.stockAvailable,
      "attributes": _vm.choices,
      "product": _vm.product,
      "initialQuantity": _vm.initialQuantity,
      "addToCartButton": false,
      "buyNowButton": false
    },
    on: {
      "resetQuantity": _vm.resetQuantity
    }
  }), _vm._v(" "), (_vm.showPageSelector) ? _c('div', {
    staticClass: "donate__wrapper"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn--purple",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.donate.apply(null, arguments)
      }
    }
  }, [_vm._v("บริจาค")])])]) : _c('div', {
    staticClass: "text-center mt-15 mb-15"
  }, [_c('button', {
    staticClass: "btn btn--purple btn-md",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.donate.apply(null, arguments)
      }
    }
  }, [_vm._v("บริจาค")])])], 1)])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fe7e2e22","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProductListItem.vue
// module id = 1242
// module chunks = 0